var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tooltip", { attrs: { text: "Download" } }, [
    _c(
      "button",
      {
        staticClass: "download-btn btn-link",
        attrs: { type: "button", "aria-label": `Download ${_vm.fileName}` },
        on: { click: _vm.download }
      },
      [
        _c("i", {
          staticClass: "fa fa-download",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }